import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { useIntl, FormattedMessage } from "react-intl";

/**
 * MainTitle:
 *   - Maintitle for all Question Components
 */
export function MainTitle(props) {
  const className = `${style.title} ${props.className}`;
  return (
    <h6 className={className} dir="auto">
      <FormattedMessage id={props.title} defaultMessage={props.title} />
    </h6>
  );
}

MainTitle.propTypes = {
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * Title text
   */
  title: PropTypes.string,
};

MainTitle.defaultProps = {
  title: "Question",
  className: "",
};
